import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class RouteMemoryService {

    private previousUrl: string = '';
    private currentUrl: string = '';
    private initialized: boolean;

    constructor(
        private router: Router
    ) { }

    init(): void {
        if (this.initialized) {
            return;
        }

        this.initialized = true;
        this.currentUrl = this.router.url;

        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.previousUrl = this.currentUrl;
                this.currentUrl = event.urlAfterRedirects;
            }
        });
    }

    getPreviousUrl(): string {
        return this.previousUrl || '';
    }
}
